import { Button, Divider, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";

import add from "../../assets/icons/add-circle.png";
import trash from "../../assets/icons/trash.png";
import { isNotEmpty } from "../../utils";
import { actionTypeOptions } from "./testData";

export default function AddActionTriggerByActionCompletion({actions, setFormData}) {
  const [andActions, setAndActions] = useState([])
  const [orActions, setOrActions] = useState([])
  const [selectedAction, setSelectedAction] = useState(null) // Track currently selected option
  const [selectedOrAction, setSelectedOrAction] = useState(null) // Track currently selected option

  const options = actions.map(action => {
    const foundOption = actionTypeOptions.find(option => option.value === action.action_type);
    return {
      label: foundOption ? foundOption.label : action.action_type, // fallback to action_type if not found
      value: action.id
    };
  });

  // Update formData whenever andActions or orActions change
  useEffect(() => {
    const relatedActionIds = [];
    let logicType = "and";
    
    if (andActions.length > 0) {
      relatedActionIds.push(...andActions.map(action => action.id));
      logicType = "and";
    } else if (orActions.length > 0) {
      relatedActionIds.push(...orActions.map(action => action.id));
      logicType = "or";
    }
    
    setFormData((prevData) => {
      return { 
        ...prevData, 
        action_trigger: { ...prevData.action_trigger, 
          trigger_type: 'action completion', 
          related_action_ids: relatedActionIds, 
          logic_type: logicType 
        }
      };
    });
  }, [andActions, orActions, setFormData]);


  const handleAdd = (type) => {
    if (!selectedAction) return; // Don't add if nothing is selected
    // Find the complete action object
    const newAction = type === "and" ? actions.find(action => action.id === selectedAction)
      : actions.find(action => action.id === selectedOrAction);
    if (!newAction) return;
    
    if (type === "and") setAndActions(prev => [...prev, newAction]);
    else if (type === "or")  setOrActions(prev => [...prev, newAction]);  
    
    // Clear the selection after adding
    setSelectedAction(null);
  };

  const handleRemoveAction = (index, type) => {
    if (type === "and") {
      setAndActions(prev => prev.filter((_, i) => i !== index));
    } else if (type === "or") {
      setOrActions(prev => prev.filter((_, i) => i !== index));
    }
  };
  

  return (
    <div style={{ padding: "10px 25px 15px", width: "100%", backgroundColor: "#F6F5FD", border: "1px solid #E0DDF7", borderRadius: 10 }}>
      <p style={{ fontSize: 14, fontWeight: 500 }}>Related Action</p>

      <div style={{ backgroundColor: "white", boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)", borderRadius: 10, padding: 12 }}>
        {/* Show created actions, if there is any */}
        {isNotEmpty(andActions) && andActions.map( (action, index) => 
            <CreatedTriggerByActionCompletionsActions key={`and-${index}`} action={action} num={andActions.length}  onRemove={() => handleRemoveAction(index, "and")} isAnd/> 
        )}

        <Tooltip title={orActions.length > 0 ? "You can choose only one logic type. \n Please delete the 'Or' Logic list if you want to make the 'And' list" : null}>
          <Select
            options={options}
            value={selectedAction}
            placeholder="Select Action"
            className="custom-style-selection"
            style={{ width: "100%", display: "flex", alignItems: "center", marginTop: 10 }}
            onChange={(value) => setSelectedAction(value)}
          />
        </Tooltip>

        <Divider type="horizontal" className="custom-divider-background-color">
          <span style={{ backgroundColor: "#EEEDFA", color: "#6B43B5", padding: "3px 5px", borderRadius: 10, fontSize: 12 }}>And</span>
        </Divider>

        <Button 
          style={{ padding: "20px 0", color: "#6B43B5", width: "100%", borderRadius: 10, fontSize: 14 }} 
          onClick={()=> handleAdd("and")} 
          disabled={!selectedAction || orActions.length > 0} // Disable if nothing selected or there is an or action selected
        >
          <img src={add} alt="add" style={{width: 18, height: 18}}/>
          Add
        </Button>
      </div>

      <Divider type="horizontal" orientation="left" orientationMargin={0} className="custom-divider-background-color"/>

      <div style={{ backgroundColor: "white", boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)", borderRadius: 10, padding: 12 }}>
        {/* Show created actions, if there is any */}
        {isNotEmpty(orActions) && orActions.map( (action, index) => 
            <CreatedTriggerByActionCompletionsActions key={`or-${index}`} action={action} num={andActions.length}  onRemove={() => handleRemoveAction(index, "or")}/> 
        )}

        <Tooltip title={andActions.length > 0 ? "You can choose only one logic type. \n Please delete the 'And' Logic list if you want to make the 'Or' list" : null}>
          <Select
            options={options}
            value={selectedOrAction}
            placeholder="Select Action"
            className="custom-style-selection"
            style={{ width: "100%", display: "flex", alignItems: "center", marginTop: 10 }}
            onChange={(value) => setSelectedOrAction(value)}
            disabled={andActions.length > 0}
          />
        </Tooltip>
        <Divider type="horizontal" className="custom-divider-background-color">
          <span style={{ backgroundColor: "#EEEDFA", color: "#6B43B5", padding: "3px 5px", borderRadius: 10, fontSize: 12 }}>Or</span>
        </Divider>
        <Button 
          style={{ padding: "20px 0", color: "#6B43B5", width: "100%", borderRadius: 10, fontSize: 14 }} 
          onClick={()=> handleAdd("or")}
          disabled={!selectedOrAction || andActions.length > 0} // Disable if nothing selected or there is an or action selected
        >
          <img src={add} alt="add" style={{width: 18, height: 18}}/>
          Add
        </Button>
      </div>

    </div>
  );
}

// Component actions component
function CreatedTriggerByActionCompletionsActions({action, num, onRemove, isAnd}) {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: 14, fontWeight: "bold" }}>{ action.action_type }</span>
          <img src={trash} alt="remove" style={{ cursor: "pointer" }} onClick={onRemove}/>
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ fontSize: 12 }}>Schedule&ensp;</span>
          <span
            style={{
              backgroundColor: "#EEEDFA",
              color: "#6B43B5",
              padding: "3px 10px",
              borderRadius: 100,
              fontSize: 12,
            }}
          >
            Action Completion - {num} Actions
          </span>
        </div>
      </div>

      <Divider type="horizontal" className="custom-divider-background-color">
        <span style={{ backgroundColor: "#EEEDFA", color: "#6B43B5", padding: "3px 5px", borderRadius: 10, fontSize: 12 }}> {isAnd ? "And" : "Or" }</span>
      </Divider>
    </>
  );
}
